export const AMPLITUDE_API_KEY = "69b4606d47988e2a0ca7460b589697a2"
export const DD_CLIENT_TOKEN = "pub837f8ba84ca10795b275ad00e07338a1"
export const RECAPTHCA_KEY = "6Lf1RbkhAAAAAOkXezBeNa8BgHYvubv5Hnc2TT8v"
export const HCAPTCHA_KEY = "55f79343-433e-4999-877a-12ccc5bbaf3f"
export const BUILD_NUM = "8722186937-976"
export const PUBLIC_PATH = "https://static.web.flipdish.com/public/"
